import {
  PlanetClass,
  PlanetClassType,
  PlanetSkillFilterInput
} from '@apeiron/planet'
import { NextImage } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import {
  ChipToggleButton,
  ChipToggleButtonGroup
} from '@src/components/share/filter/ChipToggle'
import { usePlanetClassContext } from '@src/contexts/planet/PlanetClassContext'
import { FC, MouseEvent, useCallback, useState } from 'react'

const ChipGroup = styled(ChipToggleButtonGroup)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 8px;
`

const ChipButton = styled(ChipToggleButton)`
  padding: 5px 10px 5px 8px;
  justify-content: flex-start;
  ${props => props.theme.breakpoints.up('res768')} {
    font-size: 12px;
  }
  ${props => props.theme.breakpoints.down('res768')} {
    font-size: 12px;
  }
`

const PlanetClassImage = styled(NextImage)`
  width: 19px;
  aspect-ratio: 1;
  margin-right: 6px;
`

const PlanetSkillClassFilter: FC<Props> = (props: Props) => {
  const { className, filterInput, onFilterChange } = props

  const { planetClasses } = usePlanetClassContext()

  const [selected, setSelected] = useState<PlanetClassType[]>([])

  const handleOnChange = useCallback(
    (_: any, types: PlanetClassType[]) => {
      setSelected(types)
      if (onFilterChange) {
        onFilterChange({
          ...filterInput,
          planetClasses: types
        })
      }
    },
    [filterInput, onFilterChange]
  )

  const handleOnMouseDown = useCallback((event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
  }, [])

  return (
    <Box tabIndex={-1} className={className} onMouseDown={handleOnMouseDown}>
      <ChipGroup value={selected} onChange={handleOnChange}>
        {planetClasses.map((planetClass: PlanetClass) => (
          <ChipButton key={planetClass.type} value={planetClass.type}>
            <PlanetClassImage src={planetClass.image} />
            {planetClass.name}
          </ChipButton>
        ))}
      </ChipGroup>
    </Box>
  )
}

export type Props = {
  className?: string
  filterInput: PlanetSkillFilterInput
  onFilterChange?: (input: PlanetSkillFilterInput) => void
}

export default PlanetSkillClassFilter
